/**
 * 代理返现表请求接口
 * @author 王振宇
 * @since 2022-07-02
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_AGENTCASHBACK_PAGE_LIST: function GET_AGENTCASHBACK_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agentCashBack/getPageList',
        method: 'post',
        data: data
      });
    },
    GET_AGENTCASHBACK_LIST: function GET_AGENTCASHBACK_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agentCashBack/getList',
        method: 'get',
        params: data
      });
    },
    GET_AGENTCASHBACK_INFO: function GET_AGENTCASHBACK_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agentCashBack/info',
        method: 'get',
        params: data
      });
    },
    SAVE_AGENTCASHBACK: function SAVE_AGENTCASHBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agentCashBack/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_AGENTCASHBACK: function UPDATE_AGENTCASHBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agentCashBack/update',
        method: 'put',
        data: data
      });
    },
    DELETE_AGENTCASHBACK: function DELETE_AGENTCASHBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agentCashBack/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_AGENTCASHBACK: function DELETE_BATCH_AGENTCASHBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agentCashBack/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});